import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'i2g-context-menu-item',
  templateUrl: './context-menu-item.component.html',
  styleUrls: ['./context-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuItemComponent {
  constructor() {}
}
